module.exports = __webpack_public_path__ + "img/9hearts.79b9b236.jpg";